import styled from 'styled-components'

// Matches the prototype's `dv360-metrics`/`dv360-metric` (ads-design-prototypes,
// apps/offsite/v2.html): the three headline projections (impressions, reach,
// clicks) render as bordered stat cards, not a definition list.
export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--sl-space-3);

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`

export const MetricCard = styled.div`
  border: var(--sl-border-base);
  border-radius: var(--sl-radius-2);
  padding: var(--sl-space-3) var(--sl-space-4);
  background: var(--sl-bg-base);
`

export const MetricLabel = styled.p`
  font: var(--sl-text-caption-1-font);
  color: var(--sl-fg-base-soft);
  margin: 0 0 var(--sl-space-1);
`

export const MetricValue = styled.p`
  font: var(--sl-text-emphasis-font);
  color: var(--sl-fg-base);
  margin: 0;
`
